export var StoryNodeType;
(function (StoryNodeType) {
    StoryNodeType["CUSTOMNODE"] = "customNode";
    StoryNodeType["CUSTOMGROUP"] = "customGroup";
})(StoryNodeType || (StoryNodeType = {}));
